<template>
    <div class="page-container">
        <div class="section">
            <div class="section-title">信息查询</div>
            <div class="section-block">
                <div class="reward-tab">
                    <div class="tab-item" :class="{actived:currentTab == 0}" @click="changeTab(0)">查询发货单号</div>
                    <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">物流查询</div>
                </div>
                <div class="section-content" :hidden="currentTab == 1">
                    <div class="input-grp">
                        <div class="input-name">时间</div>
                        <div class="input-ref" @click="showCalendar = true" >{{date ? date : '请选择您所发货单号的时间'}}</div>
                    </div>
                    <div class="input-grp">
                        <div class="input-name">收货人</div>
                        <input type="text" class="input-ref" v-model="consigneeName" placeholder="请输入收货人姓名"/>
                    </div>
                    <div class="btn-confirm" @click="doSearch">查询</div>
                </div>
                <div class="section-content" :hidden="currentTab == 0">
                    <div class="input-grp">
                        <div class="input-name">物流单号</div>
                        <input type="text" class="input-ref" placeholder="请输入物流单号"/>
                    </div>
                    <div class="btn-confirm">查询</div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-title">信息查询</div>
            <div class="result-block">
                <div class="noresult" v-if="resultList.length == 0">您的输入条件没有匹配数据</div>
                <template v-else>
                    <div v-for="(item,index) in resultList" :key="index">
                        <div class="result-item" >
                            <div class="info-block">
                                <span>发货单号：</span>
                                <span>{{item.orderSn}}</span>
                            </div>
                            <span class="btn-copy" v-clipboard:copy="item.orderSn" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                        </div>
                        <div class="result-item" v-if="item.expressNo">
                            <div class="info-block">
                                <span>物流单号：</span>
                                <span>{{item.expressNo}}</span>
                            </div>
                            <span class="btn-copy" v-clipboard:copy="item.expressNo" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <van-calendar v-model="showCalendar" :min-date="minData" type="range" color="#3088F5" @confirm="onConfirm" />
    </div>
</template>
<script>
import { Calendar,Notify,Toast } from 'vant'
import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            currentTab:0,//0 发货单号，1 物流
            showCalendar:false,//是否显示日期选择弹层
            date:'',
            consigneeName:'',//收货人
            startTime:'',
            endTime:'',
            resultList:[],//查询结果
        }
    },
    components:{
        [Calendar.name]:Calendar,
        [Notify.name]:Notify,
        [Toast.name]:Toast
    },
    methods:{
        copySucc(){
            Notify({ type: 'success', message: '复制成功' });
        },
        copyFail(){
            Notify({ type: 'danger', message: '复制失败' });
        },
        changeTab(tabnum){

            // this.currentTab=tabnum;
        },
        formatDate(date) {
            return `${date.getMonth() + 1}/${date.getDate()}`;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.showCalendar = false;
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            this.startTime=start.toLocaleDateString().replace(/\//g,'-');
            this.endTime=end.toLocaleDateString().replace(/\//g,'-')
        },
        doSearch(){
            $http({
                method:'post',
                url:config.api.queryOrderNo,
                data:{
                    consigneeName:this.consigneeName,
                    startTime:this.startTime,
                    endTime:this.endTime
                }
            }).then(res=>{
                if(res.errno == 0){
                    this.resultList=res.data;
                }else{
                    Toast(res.errmsg);
                }
            })
        }
    },
    computed:{
        minData(){
            return new Date(1970,7,1)
        }
    }
}
</script>
<style lang="scss" scoped>
::-webkit-input-placeholder,::placeholder{
    color:#999;
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    box-sizing: border-box;
    padding:10px;
    .section{
        margin-bottom: 25px;
        .section-title{
            color:#333;
            font-size: 15px;
            line-height: 22px;
            margin-bottom: 8px;
        }
        .section-block{
            .reward-tab{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .tab-item{
                    width:160px;
                    height:40px;
                    line-height: 40px;
                    text-align: center;
                    background:#e6e6e6;
                    font-size: 14px;
                    position: relative;
                    @media screen and (max-width: 750px){
                        border-radius: 6px 6px 0px 0px;
                    }
                    z-index: 1;
                    &:first-child{
                        &::after{
                            content:'';
                            display: block;
                            width: 0;
                            height: 0;
                            border-style: solid;
                            border-width: 36px 0 0 20px;
                            border-color: transparent transparent transparent #e6e6e6;
                            position: absolute;
                            right:-20px;
                            bottom:0;
                        }
                    }
                    &:last-child{
                        &::after{
                            content:'';
                            display: block;
                            width: 0;
                            height: 0;
                            border-style: solid;
                            border-width: 0 0 36px 20px;
                            border-color: transparent transparent #e6e6e6 transparent;
                            position: absolute;
                            left:-20px;
                            bottom:0;
                        }
                    }
                    &.actived{
                        background:#fff;
                        color:#3088F5;
                        z-index: 2;
                        &:first-child{
                            &::after{
                                border-color: transparent transparent transparent #fff;
                            }
                        }
                        &:last-child{
                            &::after{
                                border-color: transparent transparent #fff transparent;
                            }
                        }
                    }
                }
            }
            .section-content{
                padding:30px 20px;
                background: #fff;
                .input-grp{
                    margin-bottom: 13px;
                    .input-name{
                        font-size: 14px;
                        color:#333;
                        line-height: 20px;
                        margin-bottom: 5px;
                    }
                    .input-ref{
                        display: block;
                        width:100%;
                        height:38px;
                        line-height: 38px;
                        box-sizing: border-box;
                        padding:0 16px;
                        font-size: 14px;
                        border:none;
                        background: #f5f5f5;
                        color:#999;
                        @media screen and (max-width: 750px){
                            border-radius: 4px;
                        }
                    }
                }
                .btn-confirm{
                    width: 180px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
                    font-size: 14px;
                    color:#fff;
                    margin:0 auto;
                    margin-top: 30px;
                    @media screen and (max-width:750px){
                        border-radius: 26px;
                    }
                }
            }
        }
        .result-block{
            background:#fff;
            padding:0 20px;
            font-size: 14px;
            @media screen and (max-width: 750px){
                border-radius: 4px;
            }
            .noresult{
                line-height: 44px;
                color:#E12323;
            }
            .result-item{
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 12px;
                line-height: 16px;
                padding:10px 0;
                color:#666;
                .info-block{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    span{
                        &:first-child{
                            width:80px;
                        }
                    }
                }
                .btn-copy{
                    color:#E12323;
                }
            }
        }
    }
}
</style>